module.exports = __webpack_public_path__ + "static/media/img_intgration_partner_01.b19ed011.png";